/**
 * The API returns deterministic, cacheable order specifically so this can happen client-side.
 * Shuffle on each attract-loop entry; never re-request to get a new order (that defeats caching).
 */
export function shuffled<T>(items: readonly T[]): T[] {
  const copy = [...items];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = copy[i]!;
    copy[i] = copy[j]!;
    copy[j] = tmp;
  }
  return copy;
}
